import React, { useEffect, useState } from 'react';
import { API, pacienteJsonHeaders } from '../../services/pacienteConfig';
import { PacienteTabNavigation } from '../../components/paciente/PacientePortalNav';
import './PacienteDatosPage.css';

const PacienteDatosPage = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    dni: '',
    telefono: '',
    medicacion: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    fetchPerfil();
  }, []);

  const fetchPerfil = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${API}/paciente/perfil`, {
        headers: pacienteJsonHeaders(),
      });
      const data = await resp.json();
      if (data.success) {
        setFormData({
          nombre: data.data.nombre || '',
          apellido: data.data.apellido || '',
          dni: data.data.dni || '',
          telefono: data.data.telefono || '',
          medicacion: data.data.medicacion || '',
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFeedback(null);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const resp = await fetch(`${API}/paciente/perfil`, {
        method: 'PUT',
        headers: pacienteJsonHeaders(),
        body: JSON.stringify({
          nombre: formData.nombre,
          apellido: formData.apellido,
          telefono: formData.telefono,
          medicacion: formData.medicacion,
        }),
      });
      const data = await resp.json();
      if (data.success) {
        setFeedback({ type: 'success', text: 'Datos actualizados correctamente' });
        localStorage.setItem('paciente_user', JSON.stringify(data.data));
        setTimeout(() => setFeedback(null), 3000);
      } else {
        setFeedback({ type: 'error', text: data.message || 'Error al guardar' });
      }
    } catch (e) {
      setFeedback({ type: 'error', text: 'Error de conexion' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="paciente-datos-page">
      <header className="pd-header">
        <h2>Mis Datos Personales</h2>
      </header>

      <div className="pdt-content">
        {loading ? (
          <div className="pdt-loading">Cargando datos...</div>
        ) : (
          <form className="pdt-form" onSubmit={handleSave}>
            <div className="pdt-section-title">Informacion basica</div>

            <div className="pdt-field">
              <label htmlFor="dni">DNI (no editable)</label>
              <input id="dni" type="text" name="dni" value={formData.dni} disabled className="disabled-input" />
            </div>

            <div className="pdt-field">
              <label htmlFor="nombre">Nombre</label>
              <input
                id="nombre"
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>

            <div className="pdt-field">
              <label htmlFor="apellido">Apellido</label>
              <input
                id="apellido"
                type="text"
                name="apellido"
                value={formData.apellido}
                onChange={handleChange}
                required
              />
            </div>

            <div className="pdt-section-title">Contacto</div>

            <div className="pdt-field">
              <label htmlFor="telefono">Telefono (WhatsApp)</label>
              <input
                id="telefono"
                type="text"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                placeholder="Ej: 549112345678"
              />
            </div>

            <div className="pdt-section-title">Informacion medica adicional</div>

            <div className="pdt-field">
              <label htmlFor="medicacion">Medicacion actual</label>
              <input
                id="medicacion"
                type="text"
                name="medicacion"
                value={formData.medicacion}
                onChange={handleChange}
                placeholder="Si tomas alguna, indicala aqui"
              />
            </div>

            <div className="pdt-footer">
              {feedback && <div className={`pdt-feedback ${feedback.type}`}>{feedback.text}</div>}
              <button type="submit" className="pdt-save-btn" disabled={saving}>
                {saving ? 'Guardando...' : 'Guardar datos'}
              </button>
            </div>
          </form>
        )}
      </div>

      <PacienteTabNavigation activeTab="datos" />
    </div>
  );
};

export default PacienteDatosPage;
